module.exports = __webpack_public_path__ + "static/media/face-neutral.0c645fb4.svg";